/**
 * @file
 * XML RSS Parser.
 * JS for feeds integration, to parse RSS XML from a URL in the DOM.
 *
 * @see @gcsu_theme/component/large-events/twig/paragraph--component-events-large.html.twig
 *
 * @param {jQuery} element - jQuery selector, the wrapping div to contain the contents of the RSS.
 * @param {string} data - jQuery data key, which should contain the RSS URL.
 */

function GCAlertParser(Drupal, once) {
  function alertHeight() {
    const element = jQuery('.rss-alert--wrapper'); // eslint-disable-line no-undef
    const elementHeight = element.outerHeight();
    const masthead = jQuery('.masthead'); // eslint-disable-line no-undef

    masthead.css({ top: elementHeight });
  }

  function processAlert(x) {
    const array = [];
    const dataURL = x.dataset.rssAlert;

    if (dataURL) {
      if (dataURL.length) {
        jQuery.ajax({ // eslint-disable-line no-undef
          type: 'GET',
          dataType: 'xml',
          cache: false,
          url: dataURL,
          success: (e) => {
            jQuery(e) // eslint-disable-line no-undef
              .find('item>description')
              .each(function arrayPush() {
                array.push(jQuery(this).first().text()); // eslint-disable-line no-undef
              });

            if (array.length) {
              this.append(array);
              this.show();
              jQuery('header.masthead').addClass('masthead--alert-bar'); // eslint-disable-line no-undef
              alertHeight();
            }
          },
        });
      }
    }
  }

  function rssAlert(element) {
    const elementArray = once('gcsu_rss_alert', '.rss-alert--wrapper');
    elementArray.forEach(processAlert, element);
  }

  Drupal.behaviors.gcsu_rss_alert = { // eslint-disable-line no-param-reassign
    attach(context) {
      jQuery(document).ready(() => { // eslint-disable-line no-undef
        // Alert RSS.
        rssAlert(jQuery('.rss-alert--wrapper', context)); // eslint-disable-line no-undef

        jQuery(window).on('resize', () => { // eslint-disable-line no-undef
          alertHeight();
        });
      });
    }, // End of Drupal attach.
  };
}

GCAlertParser(Drupal, once); // eslint-disable-line no-undef
